<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Listado de precios</h3>
            </div>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Descripción</th>
                        <th>Precio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="cursor: pointer;" @dblclick="$emit('seleccionar', precio)" v-for="(precio, index) in precios" :key="index">
                        <td>
                            {{ precio.descripcion }}
                        </td>
                        <td>
                            {{ moneyFormat(precio.precio) }}
                        </td>
                    </tr>
                    <tr v-show="precios.length === 0">
                        <td colspan="2">
                            <strong>No se ha encontrado precios disponibles.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-buttons">
            <button @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            precios: [],
            moneyFormat: moneyFormat
        };
    },
    props: {
        itemId: {
            type: String,
            required: true
        }
    },
    methods : {
        cargarListaPrecios: function () {
            axios.get(url + '/items/' + this.itemId + '/por-codigo').then(({data}) => {
                this.precios = data.precios;
            });
        }
    },
    mounted : function () {
        this.cargarListaPrecios();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/items/ListaPrecios.vue